export function getElementsOnPage()
{
    return sessionStorage.getItem("items_per_page") ? Number(sessionStorage.getItem("items_per_page")) : 7
}